export const ButtonVariants = Object.freeze({
    Dark: 'dark',
    Light: 'light',
    Danger: 'danger',
    Action: 'action',
    Glow: 'glow',
    AuthFooter: 'auth-footer',
    Option: 'option',
    PresetPackage: 'preset-package',
    SubstepChip: 'substep-chip',
    Capsule: 'capsule',
    Stealth: 'stealth',
    AdminAction: 'admin-action',
    IconAction: 'icon-action',
    IconControl: 'icon-control',

    ChatSend: 'chat-send',
    ChatSendLight: 'chat-send-light',
    // Default NuxtUI variants
    Ghost: 'ghost',
    Link: 'link'
});
